'use client';

import SafeImage from "@/components/common/safe_image";
import classes from "./provider_registration.module.css";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import CustomButton from "../common/buttons/button";

const deletable_storage_items = ["contract_code","contract_name","contract_city","contract_address_zip","contract_street","users_name","users_street","users_city","users_address_zip","users_tax_number","provider_package","provider_questions"];

export default function ProviderRegistration({provider_types, sm_padding}) {
    const [selectedURL, setSelectedURL] = useState(false);
    const router = useRouter();

    const clickHandler = (url) => {
        setSelectedURL(url);
        if (!url) return false;
        router.push(`/szolgaltato/regisztracio/pdatas?category=${url}`);
    }

    useEffect(() => {
        deletable_storage_items.forEach(val => { if(localStorage.getItem(val)) localStorage.removeItem(val); });
    }, [])

    return <div className="d-flex flex-column align-self-stretch gap-4">
        <div className={`${classes["provider-registration-main"]} ${sm_padding ? classes["sm_padding"] : ""}`}>
            {provider_types && provider_types.length > 0 && provider_types.map(p => <div key={`provider-card-item-${p.id}`} className={`${classes["provider-card-element"]} ${(p.id.toString() === selectedURL.toString() ? classes["active"] : "")}`} onClick={() => clickHandler(p.id)} >
                <div className={`${classes["provider-card-element-inner"]}`} >
                    {p.image && <SafeImage src={p.image} width={24} height={24} priority alt={p.name} />}
                    <p className={`${classes["provider-card-element-text"]} color-gray-700 text-sm-medium`}>{p.name}</p>
                </div>
            </div>)}
        </div>
        
        <div className={`${classes["button-container"]}`}>
            <CustomButton size="lg" hierarchy="tertiary-gray" type="button" onClick={() => window.open('/mediaajanlat', '_blank')}>
                Partnerség előnyei
            </CustomButton>
        </div>
    </div>
}